import { multi, OTHER, option, single } from "../us-fields";

const FREE_FLUID = [
  option("absent", "Free fluid absent"),
  option("present", "Free fluid present"),
  option("indeterminate", "Indeterminate"),
];

export const FAST_RUQ = single("fast.ruq_free_fluid", "RUQ", FREE_FLUID, {
  normal: "absent",
});

export const FAST_LUQ = single("fast.luq_free_fluid", "LUQ", FREE_FLUID, {
  normal: "absent",
});

export const FAST_PELVIS = single(
  "fast.pelvis_free_fluid",
  "Pelvis",
  FREE_FLUID,
  { normal: "absent" },
);

export const FAST_RIGHT_PLEURAL_SPACE = single(
  "fast.right_pleural_free_fluid",
  "Right pleural space",
  FREE_FLUID,
  { normal: "absent" },
);

export const FAST_LEFT_PLEURAL_SPACE = single(
  "fast.left_pleural_free_fluid",
  "Left pleural space",
  FREE_FLUID,
  { normal: "absent" },
);

export const FAST_INTERPRETATION = multi(
  "fast.interpretation",
  "Interpretation",
  [
    option("no_free_fluid", "No peritoneal free fluid"),
    option("free_fluid", "Peritoneal free fluid"),
    option("indeterminate", "Indeterminate"),
    OTHER,
  ],
);
